import { useGetAllStations } from '@/hooks/data/masterDataHook';
import { Select, SelectProps } from 'antd';
import React from 'react';

interface Props extends SelectProps<any> {
  countryIds?: string[];
}

function StationInput({ countryIds, onChange, ...props }: Props) {
  const { data, isLoading } = useGetAllStations();
  const options = React.useMemo(() => {
    if (countryIds?.length) {
      return data?.filter(x => countryIds.includes(x.countyId || '')) || [];
    }
    return data || [];
  }, [data, countryIds]);

  return (
    <Select
      maxTagCount="responsive"
      {...props}
      loading={isLoading}
      showSearch
      allowClear
      onChange={onChange}
      filterOption={(input, option) => {
        return (option?.children as any)?.toLowerCase().includes(input.toLowerCase());
      }}
    >
      {options?.map(c => {
        return (
          <Select.Option key={c.id} value={c.id}>
            {`[${c.stationCode}] ${c.name}`}
          </Select.Option>
        );
      })}
    </Select>
  );
}

export default StationInput;
